import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { sendWarehouseData } from "../../../apis/apis.logistics/apisProduct";
import { Modal } from "../../../components/ui";

const initialState = {
    warehouseID: 0,
    warehouseName: "",
    subsidiaryID: "",
    subsidiaryName: "",
    warehouseCategory: "",
    warehouseCategoryDisplay: "",
    productDict: [],
};

const inputClass =
    "w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";
const labelClass = "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1";

export function WarehouseRegisterForm(props) {
    const [item, setItem] = useState(initialState);

    const sendWarehouse = async (registerData) => {
        try {
            const response = await sendWarehouseData(registerData);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const existsUpdateCategory = props.warehouses.find((warehouse) => {
        return (
            (warehouse.warehouseCategory == item.warehouseCategory &&
                warehouse.warehouseID != item.warehouseID &&
                item.warehouseCategory == "01") ||
            (warehouse.warehouseCategory == item.warehouseCategory &&
                warehouse.warehouseID != item.warehouseID &&
                item.warehouseCategory == "02") ||
            (warehouse.warehouseCategory == item.warehouseCategory &&
                warehouse.warehouseID != item.warehouseID &&
                item.warehouseCategory == "03")
        );
    });

    const existsCategory = props.warehouses.find((warehouse) => {
        return (
            (warehouse.warehouseCategory == item.warehouseCategory &&
                item.warehouseCategory != "01" &&
                item.warehouseCategory != "04") ||
            (warehouse.warehouseCategory == item.warehouseCategory &&
                item.warehouseCategory != "02" &&
                item.warehouseCategory != "04") ||
            (warehouse.warehouseCategory == item.warehouseCategory &&
                item.warehouseCategory != "03" &&
                item.warehouseCategory != "04")
        );
    });

    function handleChangeCategory(e) {
        var index = e.nativeEvent.target.selectedIndex;
        setItem((prevState) => ({
            ...prevState,
            warehouseCategory: e.target.value,
            warehouseCategoryDisplay: e.nativeEvent.target[index].text,
        }));
    }

    function handleChange(e) {
        setItem({ ...item, [e.target.name]: e.target.value });
    }

    function updateWarehouse(data) {
        return props.warehouses.map((warehouse) => {
            if (warehouse.warehouseID === data.warehouseID) {
                const newWarehouseItem = Object.assign({}, warehouse);
                newWarehouseItem.warehouseName = data.warehouseName;
                newWarehouseItem.warehouseCategory = data.warehouseCategory;
                newWarehouseItem.warehouseCategoryDisplay =
                    data.warehouseCategoryDisplay;
                return newWarehouseItem;
            }
            return warehouse;
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (item.warehouseID == 0) {
            if (existsCategory == undefined) {
                sendWarehouse(item)
                    .then(async (r) => {
                        const data = {
                            warehouseID: r.warehouseID,
                            warehouseName: item.warehouseName,
                            subsidiaryID: item.subsidiaryID,
                            subsidiaryName: item.subsidiaryName,
                            warehouseCategory: item.warehouseCategory,
                            warehouseCategoryDisplay: item.warehouseCategoryDisplay,
                            productDict: item.productDict,
                        };
                        return data;
                    })
                    .then((data) => {
                        if (data) {
                            props.setWarehouses((prevPlanes) => [...prevPlanes, data]);
                            props.setSelectedWarehouse(initialState);
                            toast.success("Almacén registrado con éxito!");
                        } else {
                            toast.error("Ocurrió algún error");
                        }
                    });
            } else {
                toast.error(
                    "Ya existe un almacén con esa categoría. Solo se permite repetir si es vehículo"
                );
            }
        } else {
            if (existsUpdateCategory == undefined) {
                sendWarehouse(item)
                    .then(async (r) => {
                        const data = {
                            warehouseID: r.warehouseID,
                            warehouseName: item.warehouseName,
                            subsidiaryID: item.subsidiaryID,
                            subsidiaryName: item.subsidiaryName,
                            warehouseCategory: item.warehouseCategory,
                            warehouseCategoryDisplay: item.warehouseCategoryDisplay,
                            productDict: item.productDict,
                        };
                        return data;
                    })
                    .then((data) => {
                        if (data) {
                            toast.success("Almacén actualizado con éxito!");
                            props.setWarehouses(updateWarehouse(data));
                        } else {
                            toast.error("Ocurrió algún error");
                        }
                    });
            } else {
                toast.error(
                    "Ya existe un almacén con esa categoría. Solo se permite repetir si es vehículo"
                );
            }
        }

        props.onClose();
    };

    useEffect(() => {
        if (Number(props.subsidiaryID) > 0) {
            setItem((prev) => ({
                ...prev,
                subsidiaryID: props.subsidiaryID,
                subsidiaryName: props.subsidiaryName,
            }));
        }
    }, [props.subsidiaryID, props.subsidiaryName]);

    useEffect(() => {
        if (props.selectedWarehouse.warehouseID > 0) {
            setItem({
                warehouseID: props.selectedWarehouse.warehouseID,
                warehouseName: props.selectedWarehouse.warehouseName,
                warehouseCategory: props.selectedWarehouse.warehouseCategory,
                warehouseCategoryDisplay:
                    props.selectedWarehouse.warehouseCategoryDisplay,
                productDict: props.selectedWarehouse.productDict,
                subsidiaryID: props.subsidiaryID,
                subsidiaryName: props.subsidiaryName,
            });
        } else {
            setItem({
                ...initialState,
                subsidiaryID: props.subsidiaryID,
                subsidiaryName: props.subsidiaryName,
            });
        }
    }, [props.selectedWarehouse, props.subsidiaryID, props.subsidiaryName]);

    const modalTitle = (
        <>
            <i
                className={`fas ${item.warehouseID ? "fa-edit" : "fa-plus-circle"} text-blue-600 dark:text-blue-400`}
                aria-hidden="true"
            />
            <span>{item.warehouseID ? "Editar almacén" : "Nuevo almacén"}</span>
        </>
    );

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={modalTitle}
            size="md"
        >
            <input type="hidden" value={item.warehouseID} />

            <div className="space-y-4 -mt-2">
                <div>
                    <label className={labelClass}>Nombre</label>
                    <input
                        type="text"
                        className={inputClass}
                        placeholder="Ingrese nombre del almacén..."
                        name="warehouseName"
                        maxLength={100}
                        value={item.warehouseName}
                        onChange={handleChange}
                        autoComplete="off"
                        autoFocus
                    />
                </div>

                <div>
                    <label className={labelClass}>Tipo</label>
                    <select
                        className={inputClass}
                        name="warehouseCategory"
                        onChange={handleChangeCategory}
                        value={item.warehouseCategory}
                    >
                        <option value="0">Elige</option>
                        {props.warehouseCategories.map((category, index) => (
                            <option key={index} value={category.id}>
                                {category.name}
                            </option>
                        ))}
                    </select>
                </div>

                {item.subsidiaryName && (
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                        <i className="fas fa-building mr-1" aria-hidden="true" />
                        Sede: <span className="font-medium">{item.subsidiaryName}</span>
                    </p>
                )}
            </div>

            <div className="mt-6 flex flex-wrap justify-end gap-2 border-t border-gray-200 pt-4 dark:border-gray-700">
                <button
                    type="button"
                    onClick={props.onClose}
                    className="inline-flex items-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                    Cerrar
                </button>
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="inline-flex items-center rounded-lg bg-amber-500 px-4 py-2 text-sm font-medium text-gray-900 transition-colors hover:bg-amber-600"
                >
                    <i className="fas fa-save mr-1" aria-hidden="true" />
                    Guardar
                </button>
            </div>
        </Modal>
    );
}
